import { useIsIncognito } from '#pplx/frontend/apps/ask/incognito/useIsIncognito.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { useIsMobile } from '#pplx/frontend/platform-components/useMobileStyle.js';
export function useSidebarRecentItemsEligibility(reason) {
    const { session, status } = useSession();
    const signedIn = status === 'authenticated' && Boolean(session?.user?.email);
    const { isIncognito } = useIsIncognito({ reason });
    // Content stays mounted on mobile even with the drawer closed. Keep mobile
    // on REST so every page view does not hold a websocket subscription.
    const { isMobileStyle } = useIsMobile({ evaluateOnInit: true });
    return {
        isGraphQLEligible: signedIn && !isIncognito && !isMobileStyle,
        signedIn,
        isIncognito,
        isMobileStyle,
    };
}
//# sourceMappingURL=useSidebarRecentItemsEligibility.js.map